/** Community icon upload (keep in sync with Storage bucket + RPC). */
export const COMMUNITY_ICONS_BUCKET = 'community-icons';
export const COMMUNITY_ICON_FILE_NAME = 'icon.jpg';
export const COMMUNITY_ICON_SIZE_PX = 512;
export const COMMUNITY_ICON_JPEG_QUALITY = 0.9;
export const COMMUNITY_ICON_MAX_BYTES = 1024 * 1024;

export function communityIconStoragePath(communityId: string): string {
  return `${communityId}/${COMMUNITY_ICON_FILE_NAME}`;
}
